<template>
 <div id="affirmOrder">
 	<mt-header title="确认订单"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
		  <a href="/" slot="right">
		    <mt-button><img src="../../../static/images/go_home_ico.png" width="23"/></mt-button>
		  </a>
 	</mt-header>
 	<!--实物-->	
 	<div class="bgcontent mt40" v-show="ttype==0">
 	  <!--收货人有地址时显示-->
 	   <section @click="selectAddress" v-show="addressLength!=0">
 	   	    <div class="goodsaddresswrap">
	   	 	    <span class="iconaddress">
	   	 	    	<img src="../../../static/images/address_ico.png"/>
	   	 	    </span>
				<div class=" peopleleft" >
					<p class="mAp1 clearfix font-size10 mb5"><span class="float-left">收货人：<i class="goodsPeople">{{peopleName}}</i></span> <span class="float-right">{{peoplePhone}}</span></p>
					<p class="mAp2 font-size8"><span class="mAp2-span1">收货地址：</span><span class="mAp2-span2">{{peopleAddress}}</span></p>
				</div>
				<span class=" peopleright">
					<i class="iconfont icon-youjiantou"></i>
				</span>
    	    </div>
 	   </section>
 	   <!--收货人没有地址时显示-->
 	   <section @click="selectAddress" v-show="addressLength==0">
 	   	    <div class="goodsaddresswrap justify-content">
	   	 	    <span class="iconaddress">
	   	 	    	<img src="../../../static/images/address_ico.png"/>
	   	 	    </span>
				<div class=" peopleleft" >
					<span class="mAp1 font-size10 mr5">请添加收货地址</span>
					<!--<i class="iconfont icon-youjiantou"></i>-->
				</div>
				<span class=" peopleright">
					<i class="iconfont icon-youjiantou"></i>
				</span>
    	    </div>
 	   </section>
 	   <p class="colorBox"></p>
 	   <!--图标模块-->
	  <section class="contentbox">
	  	<dl class="orderaffirm_top">
	  		<dt><img :src="urlPrefixImg+'/'+pic" alt=""/></dt>
	  		<dd>
	  			<p class="color333 font-size10">{{tName}}</p>
	  			<p class="color666 font-size8">{{proName}}</p>
	  		</dd>
	  	</dl>
	  </section>
	  <!--数量模块-->
	  <p class="colorBox"></p>
		<div>
			 <div class="reset-mintbox" >
			 	<label class="labelr">商品数量</label>
			 	<label class="labelp colorblack">{{num}}</label>
			 	<!--<input type="number" disabled  v-model="num" class="colorblack"/>-->
			 </div>
			 <div class="reset-mintbox border-bottom-line">
			 	<label class="labelr">商品金额</label>
			 	<label class="labelp">{{totalPriceOb}}</label>
			 </div>
			 <div class="reset-mintbox" >
			 	<label class="labelr">运费</label>
			 	<label class="labelp colorblack">{{freightR}}元</label>
			 	<!--<input type="text" disabled  v-model="freightR" class="colorblack"/>-->
			 </div>
			  <div @click="toticketpage">
			 	<!--to='/Ticket/useTicket'-->
				 <mt-cell title="优惠券" is-link class="border-bottom-line">
					  <span class="paycoin1">{{defaultval1}}</span>
				 </mt-cell>
			 </div>
			 <div class="reset-mintbox">
			 	<label class="labelr">订单金额</label>
			 	<label class="labelp colorOrange">{{totalPrice0}}</label>
			 	<!--<input type="text" disabled  v-model="totalPrice0" class="colorff5513"/>-->
			 	
			 </div>
		</div>
	</div>
 	
 	<!--卡密，直冲-->
 	<div v-show="ttype!=0">
		<div class="bgcontent mt40"> 
		  <section class="contentbox">
		  	<dl class="orderaffirm_top">
		  		<dt><img :src="urlPrefixImg+'/'+pic" alt=""/></dt>
		  		<dd>
		  			<p class="color333 font-size10">{{tName}}</p>
		  			<p class="color666 font-size8">{{type==1?'点卡':'充值'}}：{{proName}}</p>
		  		</dd>
		  	</dl>
		  </section>
		</div>
		<!--<p>{{ttype}}</p>-->
		<p class="colorBox"></p>
		<div>
			 <div class="reset-mintbox" v-if="type==1">
			 	<label class="labelr">商品数量</label>
			 	<!--<input type="number" disabled  v-model="num" class="colorblack"/>-->
			 	<!--<p class="labelp colorblack">{{num}}</p>-->
			 	<label class="labelp colorblack">{{num}}</label>
			 </div>
			 <div class="reset-mintbox" v-else>
			 	<label class="labelr">充值账号</label>
			 	<!--<input type="text" disabled  v-model="account" class="colorblack"/>-->
			 	<!--<p class="labelp colorblack">{{account}}</p>-->
			 	<label class="labelp colorblack">{{account}}</label>
			 </div>
			 <div class="reset-mintbox border-bottom-line">
			 	<label class="labelr">商品金额</label>
			 	<!--<input type="text" disabled  v-model="type==2?price:totalPrice" class="colorOrange"/>-->
			 	<!--<p class="labelp colorOrange">{{type==2?price:totalPrice}}</p>-->
			 	<label class="labelp">{{type==2?price:totalPrice}}</label>
			 </div>
			 <div @click="toticketpage">
			 	<!--to='/Ticket/useTicket'-->
				 <mt-cell title="优惠券" is-link class="border-bottom-line">
					  <span class="paycoin1">{{defaultval1}}</span>
				 </mt-cell>
			 </div>
			 <div class="reset-mintbox">
			 	<label class="labelr">订单金额</label>
			 	<!--<input type="text" disabled  v-model="type==2?price:totalPrice" class="colorOrange"/>-->
			 	<!--<p class="labelp colorOrange">{{type==2?price:totalPrice}}</p>-->
			 	<label class="labelp colorOrange" v-if="this.defaultval!=''||this.yamountback!==undefined">{{type==2?price1:totalPrice1}}</label>
			 	<label class="labelp colorOrange" v-else="">{{type==2?price:totalPrice}}</label>
			 </div>			 
		</div>
	</div>
	<p class="colorBox"></p>
	 <!--{{item.price | capitalizesr}}-->
		 <!--{{ttype==0?((Number(item.price*num)+Number(freightR)).toFixed(2)):((item.price*num).toFixed(2))}}-->
		  	<!--{{(item.price*num).toFixed(2)}}-->
	<div>
	  	<mt-cell title="选择支付渠道"  class="border-bottom-line color333 font-size9"></mt-cell>
	  	<div v-for="(item,index) in payType" v-show="payType.length>2&&index<2&&show==0" @click="createOrder(item.pay,ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2)))">
		  	<mt-cell :title="item.pay==1?'微信支付':item.pay==2?'支付宝支付':item.pay==3?'QQ钱包支付':item.pay==4?'V币支付':item.pay==5?'话费支付':'电话钱包支付'" is-link class="border-bottom-line">
			 <img slot="icon" target="_blank" :src="item.pay==1?'../../../static/images/pay_weixin_ico.png':item.pay==2?'../../../static/images/pay_zhifubao_ico.png':item.pay==3?'../../../static/images/pay_qqzhifu_ico.png':item.pay==4?'../../../static/images/pay_vbizhifu_ico.png':item.pay==5?'../../../static/images/pay_huafeizhifu_ico.png':'../../../static/images/pay_dhqb_ico.png'" width="24">
			  <span class="paycoin" v-show="item.price!=''&&(item.pay==4||item.pay==5||item.pay==6)"><i v-if="item.pay==5">{{ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2))}}元</i><i v-if="item.pay==4||item.pay==6">{{ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2))}}V</i></span>
		  </mt-cell>
		</div>
		<div v-for="(item,index) in payType" v-show="payType.length>2&&show==1" @click="createOrder(item.pay,ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2)))">
		  	<mt-cell :title="item.pay==1?'微信支付':item.pay==2?'支付宝支付':item.pay==3?'QQ钱包支付':item.pay==4?'V币支付':item.pay==5?'话费支付':'电话钱包支付'" is-link class="border-bottom-line">
			 <img slot="icon" :src="item.pay==1?'../../../static/images/pay_weixin_ico.png':item.pay==2?'../../../static/images/pay_zhifubao_ico.png':item.pay==3?'../../../static/images/pay_qqzhifu_ico.png':item.pay==4?'../../../static/images/pay_vbizhifu_ico.png':item.pay==5?'../../../static/images/pay_huafeizhifu_ico.png':'../../../static/images/pay_dhqb_ico.png'" width="24">
			  <span class="paycoin" v-show="item.price!=''&&(item.pay==4||item.pay==5||item.pay==6)"><i v-if="item.pay==5">{{ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2))}}元</i><i v-if="item.pay==4||item.pay==6">{{ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2))}}V</i></span>
		  	</mt-cell>
		</div>
		<div v-for="(item,index) in payType"  v-show="payType.length<3&&show==0" @click="createOrder(item.pay,ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2)))">
		  	<mt-cell :title="item.pay==1?'微信支付':item.pay==2?'支付宝支付':item.pay==3?'QQ钱包支付':item.pay==4?'V币支付':item.pay==5?'话费支付':'电话钱包支付'" is-link class="border-bottom-line">
			 <img slot="icon" :src="item.pay==1?'../../../static/images/pay_weixin_ico.png':item.pay==2?'../../../static/images/pay_zhifubao_ico.png':item.pay==3?'../../../static/images/pay_qqzhifu_ico.png':item.pay==4?'../../../static/images/pay_vbizhifu_ico.png':item.pay==5?'../../../static/images/pay_huafeizhifu_ico.png':'../../../static/images/pay_dhqb_ico.png'" width="24">
			 <span class="paycoin" v-show="item.price!=''&&(item.pay==4||item.pay==5||item.pay==6)"><i v-if="item.pay==5">{{ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2))}}元</i><i v-if="item.pay==4||item.pay==6">{{ttype==0?((Number(item.price*num)+Number(freightV)).toFixed(2)):((item.price*num).toFixed(2))}}V</i></span>
		  	</mt-cell>
		</div>
		<a href="javascript:void(0)" class="showPayType" @click="clickShow" v-show="payType.length>2">
		  <span>{{arrowText}}</span>
		  <i><img :src="arrowType" width="15"/></i>
		</a>
	</div>
	<!--<div>
	  	<mt-cell title="选择支付渠道"  class="border-bottom-line color333 font-size9"></mt-cell>
	  	<div v-for="(item,index) in payType" v-show="payType.length>2&&index<2&&show==0" @click="createOrder(item.pay)">
		  	<mt-cell :title="item.pay==1?'微信支付':item.pay==2?'支付宝支付':item.pay==3?'QQ钱包支付':item.pay==4?'V币支付':item.pay==5?'话费支付':'电话钱包支付'" is-link class="border-bottom-line">
			 <img slot="icon" target="_blank" :src="item.pay==1?'../../../static/images/pay_weixin_ico.png':item.pay==2?'../../../static/images/pay_zhifubao_ico.png':item.pay==3?'../../../static/images/pay_qqzhifu_ico.png':item.pay==4?'../../../static/images/pay_vbizhifu_ico.png':item.pay==5?'../../../static/images/pay_huafeizhifu_ico.png':'../../../static/images/pay_dhqb_ico.png'" width="24">
			  <span class="paycoin" v-show="item.price!=''&&(item.pay==4||item.pay==5||item.pay==6)"><i v-if="item.pay==5">{{item.price | capitalizesr}}元</i><i v-if="item.pay==4||item.pay==6">{{item.price | capitalizesv}}V</i></span>
		  </mt-cell>
		</div>
		<div v-for="(item,index) in payType" v-show="payType.length>2&&show==1" @click="createOrder(item.pay)">
		  	<mt-cell :title="item.pay==1?'微信支付':item.pay==2?'支付宝支付':item.pay==3?'QQ钱包支付':item.pay==4?'V币支付':item.pay==5?'话费支付':'电话钱包支付'" is-link class="border-bottom-line">
			 <img slot="icon" :src="item.pay==1?'../../../static/images/pay_weixin_ico.png':item.pay==2?'../../../static/images/pay_zhifubao_ico.png':item.pay==3?'../../../static/images/pay_qqzhifu_ico.png':item.pay==4?'../../../static/images/pay_vbizhifu_ico.png':item.pay==5?'../../../static/images/pay_huafeizhifu_ico.png':'../../../static/images/pay_dhqb_ico.png'" width="24">
			  <span class="paycoin" v-show="item.price!=''&&(item.pay==4||item.pay==5||item.pay==6)"><i v-if="item.pay==5">{{item.price | capitalizesr}}元</i><i v-if="item.pay==4||item.pay==6">{{item.price | capitalizesv}}V</i></span>
		  	</mt-cell>
		</div>
		<div v-for="(item,index) in payType"  v-show="payType.length<3&&show==0" @click="createOrder(item.pay)">
		  	<mt-cell :title="item.pay==1?'微信支付':item.pay==2?'支付宝支付':item.pay==3?'QQ钱包支付':item.pay==4?'V币支付':item.pay==5?'话费支付':'电话钱包支付'" is-link class="border-bottom-line">
			 <img slot="icon" :src="item.pay==1?'../../../static/images/pay_weixin_ico.png':item.pay==2?'../../../static/images/pay_zhifubao_ico.png':item.pay==3?'../../../static/images/pay_qqzhifu_ico.png':item.pay==4?'../../../static/images/pay_vbizhifu_ico.png':item.pay==5?'../../../static/images/pay_huafeizhifu_ico.png':'../../../static/images/pay_dhqb_ico.png'" width="24">
			 <span class="paycoin" v-show="item.price!=''&&(item.pay==4||item.pay==5||item.pay==6)"><i v-if="item.pay==5">{{item.price | capitalizesr}}元</i><i v-if="item.pay==4||item.pay==6">{{item.price | capitalizesv}}V</i></span>
		  	</mt-cell>
		</div>
		<a href="javascript:void(0)" class="showPayType" @click="clickShow" v-show="payType.length>2">
		  <span>{{arrowText}}</span>
		  <i><img :src="arrowType" width="15"/></i>
		</a>
	</div>-->
 </div>
</template>

<script>     
  import { Toast } from 'mint-ui'
  import { MessageBox } from 'mint-ui';
  import { Indicator } from 'mint-ui'
  export default{
  	data(){
		return{
		  indexflag: this.$route.query.indexflag,   //优惠券返回的标志
		  yamountback:this.$route.query.yamountback,   //选中优惠券的金额
		  orderIdback:this.$route.query.orderIdback,   //选中优惠券的ID
		  payfailbackflag:localStorage.getItem("payfailbackflag"),//支付返回标志 
		  orderIdflag:localStorage.getItem("orderIdflag"),//订单列表返回标志
		  selectId:this.$route.query.selectId,   //选择地址时用路由传过来的地址ID 
		  ttype:localStorage.getItem("ttype"), //商品类型
	      username:localStorage.getItem("username"),//用户名
	      page:1,  //请求地址页数
		  pid:localStorage.getItem("pid"),//商品ID号
		  type:localStorage.getItem("type"),//充值类型
		  account:localStorage.getItem("account"),//充值账号
		  num:localStorage.getItem("num"),//数量
		  price:localStorage.getItem("price")+"元",//单价   
		  totalPrice:localStorage.getItem("totalPrice")+"元",//商品金额
		  totalPriceOb:localStorage.getItem("totalPriceOb")+"元",//实物总价格
		  totalPrice0:"小计："+localStorage.getItem("totalPrice")+"元",//实物总价格
		  proName:localStorage.getItem("proName"),//面值名称
		  tName:localStorage.getItem("tName"),//标题名称
		  pic:localStorage.getItem("pic"),//面值图标
		  purpose:localStorage.getItem("purpose"),//购买用途
		  payType2:JSON.parse(localStorage.getItem("payType")),//支付    类型
		  citycode:localStorage.getItem("citycode"),//常登陆地
		  freightR:localStorage.getItem("freightR"),  //人民币的运费
		  freightV:localStorage.getItem("freightV"),  //V币的运费
		  arrowText:"查看更多支付方式",
		  arrowType:"../../../static/images/down_ico.png",
		  show:0,
		  orderId:"",//订单编号
		  pName:"",//商品名称
		  orderAmount:"",//订单金额
		  urlPrefix:this.URL_PREFIX,
		  urlPrefixImg:this.URL_PREFIX_IMG,
		  spsucnohua:this.URL_PAY,//支付成功后返回页面
		  spsuchua:this.URL_PAY_H,//话费支付成功后返回页面
		  spsuc:"",
		  //adDefault:[],  //地址
		  peopleName:'',//姓名
		  peoplePhone:'',//电话
		  peopleAddress:'',//地址
		  addressLength:0, //地址数量
		  addressId:this.$route.query.selectId,//创建实物订单时的收货地址id
		  abticketlength:-1,//有无优惠券
		  defaultval:'',//默认优惠券额度
		  defaultval1: '',//默认优惠券额度
		  //defaulticksure: localStorage.getItem("defaultval1"),//使用优惠券
		  ticketorderId:'',//优惠券Id
		  price1:'',
		  totalPrice1: '',
		  md5sign:this.Act_md5sign,
//		  available:[],
		}
	},
	//支付类型排序
	computed:{
	   payType:function(){
	   	let arr=this.payType2;
	   	function fn(a,b){
				return a.sort - b.sort;
			}
			arr.sort(fn); 
	   	 return arr; 
	   }
	},
	created:function(){
		if(this.num==""){
	       this.num=1;
	    };
	    if(this.ttype==0&&this.selectId==undefined){
	    	this.showaddressList();//显示默认地址
	    }if(this.ttype==0&&this.selectId!=undefined){
	    	this.selectAction();//显示选择的地址
	    };
	    this.getTicketinfo();
	   
	},
	methods: {
		returnBack(){
	        	MessageBox.confirm('',{
	        		message:'确定要放弃此次付款?',
	        		title:'提示'
	        	}).then(action => {
                 this.returnBack2();
                 },
	             action=>{
//	             	console.log('取消了删除操作');
	             },
	        	);
	        },
		returnBack2(){
            if(this.payfailbackflag=="true"||this.indexflag!="undefined"){
            	this.$router.push({path: "/"});
            }else{
            	if(this.ttype==0&&this.orderIdflag==''){
				this.$router.push({path: "/Reallygood"});//实物
				}else if(this.ttype==0&&this.orderIdflag!=''){
					this.$router.push({path: "/UserCenter"});//用户个人中心
				}else{
					this.$router.go(-1);
				}             	
           }            
	    },
	    toticketpage(){
	    	this.$router.push({path: "/Ticket/useTicket",query: {ticketorderId:this.ticketorderId}});
	    },
	    //创建订单
	    createOrder(payType,phoneprice){	    	
	    if(payType==1||payType==2||payType==3||payType==4||payType==6||(payType==5&&(phoneprice==1.00||phoneprice==2.00||phoneprice==4.00||phoneprice==5.00||phoneprice==6.00||phoneprice==8.00||phoneprice==10.00||phoneprice==12.00||phoneprice==15.00 ||phoneprice==20.00 ||phoneprice==25.00 ||phoneprice==30.00))){
	    	if(payType==5){
	    		this.spsuc=this.spsuchua;	    		
	    	}else{
	    		this.spsuc=this.spsucnohua;
	    	}
	    	var phoneMd=md5(this.username+"&"+this.md5sign);
	        var sign1;
	        if(this.ticketorderId==""){
	        	sign1 = md5('proId='+this.pid+'&payType='+payType+'&num='+this.num+'&phone='+phoneMd+'&'+this.md5sign);
	        }else{
	        	sign1 = md5('proId='+this.pid+'&payType='+payType+'&num='+this.num+'&phone='+phoneMd+'&coupons='+this.ticketorderId+'&'+this.md5sign);
	        }
	      	//实物
	    	if(this.ttype==0){
	    		if(this.addressLength==0){
	    		   Toast('请先添加收货地址');
	    		}else{
	                this.$http.post(this.URL_PREFIX+"/order/createOrder.net",{phone:this.username,proId:this.pid,num:this.num,payType:payType,spsuc:this.spsuc,addressId:this.addressId,coupons:this.ticketorderId,sign:sign1})
			  	    .then((res) =>{	
				  	  if(res.data.code!=200){
				  	  	  Toast(res.data.msg);
				  	  }else{
				  	  	  var orderId=res.data.remarks;
				  	  	  localStorage.setItem("orderId",orderId);
				
				  	  	  location.href=res.data.obj;
				  	  }
			  	    });
		  	   }
	    	}else{ //卡密,直充
	    	  	this.$http.post(this.URL_PREFIX+"/order/createOrder.net",{phone:this.username,proId:this.pid,num:this.num,payType:payType,rechPhone:this.account,purpose:this.purpose,areaCode:this.citycode,spsuc:this.spsuc,coupons:this.ticketorderId,sign:sign1})
		  	    .then((res) =>{
			  	  if(res.data.code!=200){
			  	  	  Toast(res.data.msg);
			  	  }else{
			  	  	  var orderId=res.data.remarks;
			  	  	  localStorage.setItem("orderId",orderId);
			  	  	 location.href=res.data.obj;
			  	  }
		  	   });
	    	}
	    	}else{
	    	   Toast('该订单金额不支持话费支付');
	    	}
	    },
	    //查看更多支付方式
	    clickShow(){
	    	if(this.arrowText=="查看更多支付方式"){
	    		this.arrowText="收起";
	    		this.arrowType="../../../static/images/up_ico.png";
	    		this.show=1;
	    	}else{
	    		this.arrowText="查看更多支付方式";
	    		this.arrowType="../../../static/images/down_ico.png";
	    		this.show=0;
	    	}
	    },
	    //点击收货人进行地址跳转
	    selectAddress(){
            this.$router.push("/UserCenter/selectAddress?label=order"); 
	    },
	    //请求默认地址
    	showaddressList(){
    		this.$http.post(this.URL_PREFIX+"/user/findAddressAll.net",{uid:this.username,page:this.page,rows:25})
		  	  .then((res) =>{
		  	   this.addressLength=res.data.rows.length;
		  	   if(res.data.rows.length!=0){
		  	   	   let Array=res.data.rows; //遍历获取默认地址
			  	   let adDefault =[];
			  	   for(let i=0;i<Array.length;i++){
			  	   	 if(Array[i].flag==1){
			  	   	 	this.addressId=Array[i].id; //收货地址id
			  	   	 	adDefault.push(Array[i]);
			  	   	 }
			  	   }
			  	   this.peopleName=adDefault[0].name;
			  	   this.peoplePhone=adDefault[0].phone;
			  	   this.peopleAddress=adDefault[0].address;
		  	   }
		  	  });
    	},
    	//选择地址时根据地址id请求相应地址
    	selectAction(){
    		this.$http.post(this.URL_PREFIX+"/user/findAddressById.net",{id:this.selectId})
		  	  .then((res) =>{
		  	   this.addressLength=1;
		  	   this.peopleName=res.data.obj.name;               //用户名
		  	   this.peoplePhone=res.data.obj.phone;          //电话号码     
		  	   this.peopleAddress=res.data.obj.address;        //收货地址
		  	  });
    	},
    	//获取可使用的优惠券信息
    	getTicketinfo(){
    		var signMd=md5('pid='+this.pid+'&num='+this.num+'&uid='+this.username+'&isuse='+1+'&'+this.md5sign);
    		this.$http.post(this.URL_PREFIX+"/activity/findAvailableCoupon",{pid:this.pid, num:this.num, uid:this.username,isuse:1,sign:signMd,page:1,rows:15})
		  	  .then((res) =>{
		  	  	this.abticketlength = res.data.obj.available.length;
		  	  	var available = res.data.obj.available;
		  	  	if(this.indexflag!=undefined){
		  	  		if(this.indexflag==-1){
		  	  			this.defaultval1='未使用';
		  	  			this.ticketorderId = '';
		  	  			this.price1 = localStorage.getItem("price") + '元';
		  	  			this.totalPrice1 = localStorage.getItem("totalPrice")+ '元';
		  	  			this.totalPrice0='小计：'+localStorage.getItem("totalPrice")+ '元';//实物小计金额
		  	  		}else{
			  	  		this.defaultval1='-' + this.yamountback + '元';
			  	  		this.ticketorderId = this.orderIdback;
			  	  		this.price1 = (localStorage.getItem("price")- this.yamountback).toFixed(2) + '元';
			  	  		this.totalPrice1 = (localStorage.getItem("totalPrice")- this.yamountback).toFixed(2) + '元';
			  	  		this.totalPrice0='小计：'+(localStorage.getItem("totalPrice")- this.yamountback).toFixed(2) + '元';//实物小计金额
		  	  		}
		  	  	}else{
			  	  	if(this.abticketlength!=0){
			  	  		var maxmoney = available[0].yamount; //可用优惠券第一个使用额度
			  	  		this.ticketorderId = available[0].orderId; //可用优惠券第一个优惠券的ID
			  	  		var maxmoneyarr = []; //具有相同优惠金额的优惠券数组
			  	  		var endtimesarr =[];  //相同过期时间的优惠券数组
			  	  		this.defaultval= maxmoney;
			  	  	    this.defaultval1='-' + maxmoney + '元';
			  	  		this.price1 = (localStorage.getItem("price")- maxmoney).toFixed(2) + '元';
			  	  		this.totalPrice1 = (localStorage.getItem("totalPrice")- maxmoney).toFixed(2) + '元';
			  	  		this.totalPrice0='小计：'+(localStorage.getItem("totalPrice")- available[0].yamount).toFixed(2) + '元';//实物小计金额
			  	  	}else{
			  	  		this.defaultval1 = '暂无可用';		  	  		
			  	  	}
		  	    }
		  	  });
    	}
    	 //话费面值验证
//	     validatephonesize(a1,b1){
//	     	if(a1==b1==1||b1== 2 ||b1==4 ||b1==5 ||b1==6 ||b1==8 ||b1==10 ||b1==12 ||b1==15 ||b1==20 ||b1==25 ||b1==30){
//	     	  this.createOrder1();
//	     	}else{
//	     	  Toast("该订单金额不支持话费支付");  
//	     	}
//	     }
	}
  }
</script>
<style scoped="scoped">
.reset-mintbox{height: 48px;line-height: 48px;padding: 0 15px 0 15px;background: #fff;border-bottom: 1px solid #eee;}
.reset-mintbox .labelr{float: left;color: #666;font-size: 0.8rem;}
/*.reset-mintbox input{text-align: right;float: right;color: #333;font-size: 0.9rem;border: none;margin-top: 14px;}*/
/*.reset-mintbox .labelp{text-align: right;float: right;color: #333;font-size: 0.9rem;border: none;margin-top: 14px;width: 180px;height: 19px;}*/
.reset-mintbox .labelp{text-align: right;float: right;color: #333;font-size: 0.9rem;border: none;}
.contentbox{background: #fff;padding: 15px 10px;}
.orderaffirm_top{overflow: hidden;}
.orderaffirm_top dt img{width: 100%;}
.orderaffirm_top dt{width: 50px;float: left;}
.orderaffirm_top dd{float: left;margin-left: 20px;}
.orderaffirm_top dd p{line-height: 25px;}
.reset-mintbox input.colorff5513{color:#ff5513;}
.paycoin{margin-right: 12px;color: #ff5513;font-size: 0.8rem;}
.paycoin1{margin-right: 12px;color: #000;font-size: 0.8rem;}
.showPayType{color: #999;font-size: 0.8rem;width: 100%;height: 50px;line-height: 50px;background: #fff;display: inline-block;text-align: center;}
.goodsPeople{width: 300px; height: 1.0rem; overflow: hidden;}
/*收货人*/
/*.orderType{padding:10px;background: #fff;}
.orderType p{line-height: 25px;}
.goodsaddresswrap{overflow: hidden;}
.addresswrap{float: left;width: 89%;margin-left: 6px;}
.iconaddress{float: left;width: 25px;margin-top: 14px;}
.iconaddress img{width: 100%;}
.peopleleft{width: 92%;}
.peopleright{width: 8%;margin-top: 25px;box-sizing: border-box;padding-left: 5px;}*/

/*收货人弹性盒*/
.goodsaddresswrap{display: flex;padding:15px 10px;align-items: center;justify-content: space-between;}
.iconaddress{width: 30px;}
.iconaddress img{width: 100%;}
.peopleleft{margin-left: 5px;margin-right: 3px;color: #666;flex: 1;}
/*.justify-content{justify-content: space-between;}*/
</style>


// WEBPACK FOOTER //
// src/views/Order/index.vue